import {clsx} from 'clsx';
import styles from './user-menu.module.css';

type Props = {
  readonly myPagePath:
    | {isLoading: true}
    | {isLoading: false; value: string | undefined};
  readonly showLoginModal: () => void;
  readonly isSearchFormExpanded: boolean;
};

export function UserMenu({
  myPagePath,
  showLoginModal,
  isSearchFormExpanded,
}: Props) {
  if (isSearchFormExpanded) return null;

  const onClickLogin = () => {
    const {window} = globalThis;

    const isPc =
      /(iphone|ipod|ipad|android|mobile)/i.exec(window.navigator.userAgent) ===
      null;
    if (isPc) {
      showLoginModal();
    } else {
      window.location.href = '/main/html/login';
    }
  };

  return (
    <div className={styles.container}>
      <div className={clsx(styles.pc, styles.staticMenus)}>
        <a href='/user_info' className={styles.link}>
          プレスリリースを受信
        </a>
        <a href='/main/registcorp/form' className={styles.link}>
          企業登録申請
        </a>
      </div>

      {myPagePath.isLoading ? (
        <span aria-hidden='true' className={styles.placeholderWidth} />
      ) : myPagePath.value === undefined ? (
        <>
          {/* SP */}
          <div className={clsx(styles.sp, styles.spGuest)}>
            <button
              type='button'
              className={styles.link}
              onClick={onClickLogin}
            >
              ログイン
            </button>
            <a
              className={clsx(styles.link, styles.admin)}
              href='/main/html/regist'
            >
              新規登録
            </a>
          </div>

          {/* PC */}
          <button
            type='button'
            className={clsx(styles.link, styles.pc, styles.placeholderWidth)}
            onClick={onClickLogin}
          >
            ログイン
          </button>
        </>
      ) : (
        <a className={clsx(styles.link, styles.admin)} href={myPagePath.value}>
          管理画面
        </a>
      )}
    </div>
  );
}
